import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFeedView } from '../state/actions';
import { theme } from '@style';
import { menus } from '@const';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
const Text = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.palette.menuText};
  font-size: ${theme.fontSizes.md};
  padding-right: 8px;
`;
const Icons = styled.div`
  display: flex;
  align-items: center;
  background: ${props => props.theme.palette.menuIcons};
  border: 1px solid ${theme.palette.gray};
  border-radius: 4px;
`;
const VerticalLine = styled.div`
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  width: 1px;
  height: 16px;
`;

const ThickLine = styled.div`
  background: ${props => props.theme.palette.menuLine};
  width: 24px;
  height: 6px;
`;
const BigLine = styled.div`
  background: ${props => props.theme.palette.menuLine};
  width: 24px;
  height: 9px;
`;

type MenuProps = {
  isActive?: boolean;
};

const Menu = styled.div<MenuProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px;
  height: 20px;
  cursor: pointer;

  > div {
    background: ${props => props.isActive && props.theme.palette.menuActive};
  }
  &:hover > div {
    background: ${props => props.theme.palette.menuActive};
  }
`;

const ThickMenu = ({
  isActive,
  onClick,
}: {
  isActive?: boolean;
  onClick: () => void;
}) => (
  <Menu isActive={isActive} onClick={onClick}>
    <ThickLine />
    <ThickLine />
    <ThickLine />
  </Menu>
);

const BigMenu = ({
  isActive,
  onClick,
}: {
  isActive?: boolean;
  onClick: () => void;
}) => (
  <Menu isActive={isActive} onClick={onClick}>
    <BigLine />
    <BigLine />
  </Menu>
);

export const Dashboard = () => {
  const feedView: string = useSelector(state => state.app.feedView);
  const dispatch = useDispatch();
  const setMenu = (feedType: string) => dispatch(toggleFeedView(feedType));

  return (
    <Wrapper>
      <Text>View</Text>
      <Icons>
        <BigMenu
          isActive={feedView === menus.BIG_MENU}
          onClick={() => setMenu(menus.BIG_MENU)}
        />
        <VerticalLine />
        <ThickMenu
          isActive={feedView === menus.THICK_MENU}
          onClick={() => setMenu(menus.THICK_MENU)}
        />
      </Icons>
    </Wrapper>
  );
};
